import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** Lib Imports */
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import MolForm, { Field } from "@moltech/molui/molform";
import Toast from "@moltech/molui/toast";

/** Utilities */
import {
  validateConfirmPassword,
  validatePassword,
} from "../../utils/validators/FieldsValidators";
import { decryptUrlData } from "../../utils/encryption/CryptoService";

/** RTK Query */
import { useChangePasswordMutation } from "../../app/services/authApi";

/** CSS */
import "./ResetPassword.scss";

const initialValue = {
  email: "",
  password: "",
  confirmPassword: "",
};

const ResetPassword = () => {
  const loginFormRef = useRef();
  const navigate = useNavigate();
  const params = useParams();
  const email = params.email ? decryptUrlData(params.email) : params.email;

  const [formValues] = useState(initialValue);

  const [changePassword, { isLoading: isSavingData }] = useChangePasswordMutation();

  const handleFormSubmit = async () => {
    const formData = loginFormRef.current?.getData();
      const req = {
        email: email,
        oldPassword: formData.password,
        newPassword: formData.confirmPassword,
      };
    if (formData) {
      try {
        await changePassword(req).unwrap();
        Toast.success("Password reset successfully!");
        navigate("/login");
      } catch (err) {
        Toast.error(err?.data?.title || err?.data?.message || "Something went wrong!");
      }
    }
  };

  const handleReturnClick = () => {
    navigate("/login");
  };

  const onSave = () => {
    if (loginFormRef.current) {
      loginFormRef.current.submit();
    }
  };

  return (
    <div className="reset-password-page">
      <div className="login-page-card">
        <div className="login-form">
          <div className="login-card">
            <img className="big-logo" src="/images/logo.png" alt="logo" />
            <h2>Welcome to MoltechR</h2>
            <p className="sub-text">
              {" "}
              Enter new password to reset your password.
            </p>
            <div className="saporate-line"></div>

            <MolForm
              ref={loginFormRef}
              onSubmit={handleFormSubmit}
              initialValues={formValues}
            >
              <div className="form-field">
                <Field
                  component={InputText}
                  value={email}
                  name="email"
                  label="Email Address"
                  disabled
                  autofill="off"
                  placeholder="Please Enter Email Address"
                  required
                />
              </div>
              <div className="form-field">
                <Field
                  component={Password}
                  feedback={true}
                  toggleMask
                  autoComplete="new-password"
                  inputProps={{ autoComplete: 'new-password' }}
                  name="password"
                  label="Password"
                  placeholder="Please Enter Password"
                  required
                  validation={validatePassword}

                />
              </div>
              <div className="form-field">
                <Field
                  component={Password}
                  feedback={false}
                  toggleMask
                  autoComplete="new-password"
                  inputProps={{ autoComplete: 'new-password' }}
                  name="confirmPassword"
                  label="Confirm Password"
                  placeholder="Please Enter Confirm Password"
                  required
                  validation={validateConfirmPassword}
                />
              </div>
            </MolForm>

            <Button
              label="Reset Password"
              loading={isSavingData}
              disabled={isSavingData}
              className="btn primary-btn  login-btn"
              onClick={onSave}
            />
            <Button
              label="Return to Login"
              loading={false}
              className="btn login-btn-outline"
              onClick={handleReturnClick}
            />

            <div className="bottom-text">
              <span>
                A lightweight HR management system that helps track employees,
                attendance, and leave requests in one place. Make workforce
                management easier and more efficient!
              </span>
            </div>
          </div>
        </div>
        <div className="login-image">
          <img src="/images/login-bg.png" alt="HRMS" />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
